import {
  Button,
  Checkbox,
  Col,
  Divider,
  Input,
  Modal,
  Row,
  Space,
  Table,
  Tooltip,
} from 'antd';
import { InputGroup } from 'react-bootstrap';
import { useContext, useEffect, useState } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import axios from 'axios';
import CreateCancel from 'components/forms/CreateCancel';
import Excel from 'components/table/excel';
import CustomPagination from 'components/table/pagination';
import ModalDelete from 'components/tabel/ModalDelete';
import toaster from 'helper/toaster';
import DashboardContext from 'Context';
import AddressForm from './form';
import InputFarsi from 'components/inputs/InputFarsi';

export default function B2BAddress() {
  const { state } = useLocation();
  const history = useHistory();
  const {
    SohwaddFrom,
    handelAdd,
    handelEdit,
    urldashboard,
    authentication,
    handelerrors,
    accessPage,
  } = useContext(DashboardContext);
  // primary
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [headers, setHeaders] = useState([]);
  const [addressId, setAddressId] = useState('');
  const [addressInfo, setAddressInfo] = useState({});
  const [searchValue, setSearchValue] = useState('');
  const [totalRecord, setTotalRecord] = useState(0);
  const [pagination, setPagination] = useState({
    page: 1,
    pageSize: 10,
  });
  // action modals
  const [deleteModal, setDeleteModal] = useState(false);
  const [sectionsModal, setSectionsModal] = useState(false);
  const [sectionsFormModal, setSectionFormModal] = useState(false);
  // secondary
  const [formData, setFormData] = useState({});
  const [sections, setSections] = useState([]);
  const [services, setServices] = useState([]);
  const [sectionInfo, setSectionInfo] = useState({});
  const [sectionsLoading, setSectionsLoading] = useState(false);
  const [servicesLoading, setServicesLoading] = useState(false);
  const [isEditingSection, setIsEditingSection] = useState(false);
  const [submitSectionLoading, setSubmitSectionLoading] = useState(false);

  useEffect(() => {
    if (!deleteModal && !sectionsModal) {
      getCompanyAddresses({
        page: pagination?.page,
        pageSize: pagination?.pageSize,
        searchValue,
      });
      setAddressId('');
      setAddressInfo({});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [handelAdd, deleteModal, sectionsModal]);

  const getCompanyAddresses = async ({ page, pageSize, searchValue }) => {
    setLoading(true);
    try {
      let url = '/B2BAddress/get';
      const res = await axios.post(
        urldashboard + url,
        JSON.stringify({
          page,
          pageSize,
          search: searchValue,
          companyId: state?.id,
        }),
        {
          headers: {
            Authorization: authentication,
            'Content-Type': 'application/json',
          },
        }
      );
      const data = await res.data;
      setHeaders(data?.headers?.map((item) => item.label));
      const items = data?.data?.map((obj) => ({ ...obj, key: obj.id }));
      setData(items);
      setTotalRecord(data?.totalRecord);
      setPagination({
        page: page,
        pageSize: pageSize,
        total: data?.totalRecord,
      });
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setData([]);
    }
  };

  const handlePagination = (newPage, newPageSize) => {
    getCompanyAddresses({
      page: newPage,
      pageSize: newPageSize,
      searchValue,
    });
  };

  const search = () => {
    getCompanyAddresses({
      page: 1,
      pageSize: 10,
      searchValue,
    });
  };

  const columns = [
    {
      title: 'ردیف',
      dataIndex: 'index',
      key: 'index',
      responsive: ['xl', 'lg'],
      render: (_, record, index) => (
        <>{index + 1 + (pagination?.page - 1) * pagination?.pageSize}</>
      ),
    },
    {
      title: 'فعال/غیرفعال',
      dataIndex: 'isActive',
      key: 'isActive',
      responsive: ['xl', 'lg', 'md', 'sm', 'xs'],
      render: (value, record) => (
        <>
          <Tooltip
            title={
              accessPage.includes('ActiveOrDeactive')
                ? value
                  ? 'غیرفعالسازی'
                  : 'فعالسازی'
                : 'دسترسی ندارید'
            }
          >
            <Checkbox
              checked={value}
              onChange={() => onSelectChangeAddress(record?.id, value)}
              disabled={!accessPage.includes('ActiveOrDeactive')}
            />
          </Tooltip>
        </>
      ),
    },
    {
      title: 'آدرس',
      dataIndex: 'addressName',
      key: 'addressName',
      responsive: ['xl', 'lg', 'md', 'sm', 'xs'],
    },
    {
      title: 'نام مسئول',
      dataIndex: 'responsibleName',
      key: 'responsibleName',
      responsive: ['xl', 'lg', 'md', 'sm', 'xs'],
    },
    {
      title: 'بخش ها',
      dataIndex: 'index',
      key: 'index',
      responsive: ['xl', 'lg', 'md', 'sm', 'xs'],
      render: (_, record) => (
        <Button onClick={() => handleSections(record)}>
          <i
            className='mdi mdi-alpha-s-circle'
            style={{ fontSize: '1rem' }}
          ></i>
        </Button>
      ),
    },
    {
      title: 'ویرایش',
      dataIndex: 'index',
      key: 'index',
      responsive: ['xl', 'lg', 'md', 'sm', 'xs'],
      render: (_, record) => (
        <Button onClick={() => handleEditAddress(record?.id)}>
          <i className='mdi mdi-pencil' style={{ fontSize: '1rem' }}></i>
        </Button>
      ),
    },
    {
      title: 'حذف',
      dataIndex: 'index',
      key: 'index',
      responsive: ['xl', 'lg', 'md', 'sm', 'xs'],
      render: (_, record) => (
        <Button onClick={() => handleDelete(record?.id)}>
          <i className='mdi mdi-delete' style={{ fontSize: '1rem' }}></i>
        </Button>
      ),
    },
  ];

  const sectionColumns = [
    {
      title: 'فعال/غیرفعال',
      dataIndex: 'isActive',
      key: 'isActive',
      responsive: ['xl', 'lg', 'md', 'sm', 'xs'],
      render: (value, record) => (
        <>
          <Tooltip title={value ? 'غیرفعالسازی' : 'فعالسازی'}>
            <Checkbox
              checked={value}
              onChange={() => onSelectChangeSections(record?.id, value)}
            />
          </Tooltip>
        </>
      ),
    },
    {
      title: 'بخش',
      dataIndex: 'name',
      key: 'name',
      responsive: ['xl', 'lg', 'md', 'sm'],
    },
    {
      title: 'کد',
      dataIndex: 'costCentreCode',
      key: 'costCentreCode',
      responsive: ['xl', 'lg', 'md'],
    },
    {
      title: 'خدمات',
      dataIndex: 'businessGroups',
      key: 'businessGroups',
      responsive: ['xl', 'lg', 'md'],
      render: (services) => (
        <>
          {services?.length > 0 ? (
            <div
              style={{
                fontWeight: '100',
                fontSize: '0.8rem',
                whiteSpace: 'nowrap',
                wordBreak: 'break-word',
              }}
            >
              {services?.map((value, index) => (
                <div key={index}>
                  <span>{value}</span>
                </div>
              ))}
            </div>
          ) : (
            <span>-</span>
          )}
        </>
      ),
    },
    {
      title: 'ویرایش',
      dataIndex: 'index',
      key: 'index',
      responsive: ['xl', 'lg', 'md', 'sm', 'xs'],
      render: (_, record) => (
        <Button onClick={() => handleEditSection(record)}>
          <i className='mdi mdi-pencil' style={{ fontSize: '1rem' }}></i>
        </Button>
      ),
    },
  ];

  const servicesColumns = [
    {
      title: 'انتخاب',
      dataIndex: 'isSelect',
      key: 'isSelect',
      responsive: ['xl', 'lg', 'md', 'sm', 'xs'],
      render: (value, record) => (
        <Checkbox
          defaultChecked={value}
          disabled={value}
          onChange={() => onSelectChangeServices(record?.key)}
        />
      ),
    },
    {
      title: 'نام',
      dataIndex: 'value',
      key: 'value',
      responsive: ['xl', 'lg', 'md', 'sm', 'xs'],
    },
    {
      title: 'لینک ویدیوی راهنمای خدمت',
      dataIndex: 'key',
      key: 'key',
      responsive: ['xl', 'lg', 'md', 'sm'],
      render: (key, record) => (
        <InputFarsi
          dir={'ltr'}
          name='videoUrl'
          Placeholder={'https://'}
          defaultValue={record?.videoUrl}
          formGroupStyle={{ marginBottom: 0 }}
          handelValue={(_, value) => rowOnChange(value, key)}
        />
      ),
    },
  ];

  const handleEditAddress = (id) => {
    handelEdit(id);
    handelAdd(true);
  };

  const handleDelete = (id) => {
    setAddressId(id);
    setDeleteModal(true);
  };

  const handleAddSection = () => {
    setServicesLoading(true);
    getServices();
    setSectionFormModal(true);
  };

  const handleEditSection = (record) => {
    setServicesLoading(true);
    getSectionServices(record?.id);
    setSectionInfo(record);
    setIsEditingSection(true);
    setSectionFormModal(true);
  };

  const getSections = async (id) => {
    try {
      let url = `/B2BAddressSection/getByAddressId/${id}`;
      const response = await axios.get(urldashboard + url, {
        headers: {
          Authorization: authentication,
          'Content-Type': 'application/json',
        },
      });
      const data = await response?.data?.data;
      setSections(data);
      setSectionsModal(true);
      setSectionsLoading(false);
    } catch (error) {
      handelerrors(error);
      setSectionsLoading(false);
    }
  };

  const handleSections = (record) => {
    setAddressInfo(record);
    setAddressId(record?.id);
    setSectionsLoading(true);
    getSections(record?.id);
  };

  const getServices = async () => {
    try {
      let url = `/B2BGroup/getForSection/${state?.id}`;
      const response = await axios.get(urldashboard + url, {
        headers: {
          Authorization: authentication,
          'Content-Type': 'application/json',
        },
      });
      const data = await response?.data?.data;
      const items = data?.map((obj) => ({ ...obj, videoUrl: '' }));
      setServices(items);
      setServicesLoading(false);
    } catch (error) {
      handelerrors(error);
      setServicesLoading(false);
    }
  };

  const getSectionServices = async (id) => {
    try {
      let url = `/B2BAddressSectionBusinessGroup/getByAddressSectionId/${id}`;
      const response = await axios.get(urldashboard + url, {
        headers: {
          Authorization: authentication,
          'Content-Type': 'application/json',
        },
      });
      const data = await response?.data?.data;
      setServices(data);
      setServicesLoading(false);
    } catch (error) {
      handelerrors(error);
      setServicesLoading(false);
    }
  };

  const onSelectChangeAddress = (rowId, isActive) => {
    markAsActiveAddress(rowId, isActive);
  };

  const markAsActiveAddress = async (rowId, isActive) => {
    setLoading(true);
    try {
      const res = await axios.delete(
        `${urldashboard}/B2BAddress/activeOrDeactive/${rowId}/${!isActive}`,
        {
          headers: {
            Authorization: authentication,
            'Content-Type': 'application/json',
          },
        }
      );
      const data = res?.data;
      toaster.success(data.message);
      setLoading(false);
      getCompanyAddresses({
        page: pagination?.page,
        pageSize: pagination?.pageSize,
        searchValue,
      });
    } catch (error) {
      setLoading(false);
      handelerrors(error);
    }
  };

  const onSelectChangeServices = (rowId) => {
    services?.forEach((element, index) => {
      if (element?.key === rowId) {
        services[index].isSelect = !services[index].isSelect;
      }
    });
  };

  const rowOnChange = (url, rowId) => {
    services?.forEach((element, index) => {
      if (element?.key === rowId) {
        services[index].videoUrl = url;
      }
    });
  };

  const onSelectChangeSections = (rowId, isActive) => {
    markAsActiveSection(rowId, isActive);
  };

  const markAsActiveSection = async (rowId, isActive) => {
    setSectionsLoading(true);
    try {
      const res = await axios.delete(
        `${urldashboard}/B2BAddressSection/activeOrDeactive/${rowId}/${!isActive}`,
        {
          headers: {
            Authorization: authentication,
            'Content-Type': 'application/json',
          },
        }
      );
      const data = res?.data;
      toaster.success(data.message);
      setSectionsLoading(false);
      getSections(addressId);
    } catch (error) {
      setSectionsLoading(false);
      handelerrors(error);
    }
  };

  const submitSection = async () => {
    setSubmitSectionLoading(true);

    let sectionFields = {
      name: formData?.name ? formData?.name : sectionInfo?.name,
      costCentreCode: formData?.costCentreCode
        ? formData?.costCentreCode
        : sectionInfo?.costCentreCode,
    };

    try {
      let url = isEditingSection
        ? '/B2BAddressSection/update'
        : '/B2BAddressSection/create';
      let id = sectionInfo?.id;
      let businessGroupIds = services
        ?.filter((item) => item.isSelect)
        ?.map((service) => {
          return {
            businessGroupId: service?.key,
            videoUrl: service?.videoUrl,
          };
        });

      if (businessGroupIds?.length < 1) {
        setSubmitSectionLoading(false);
        return toaster.error('لطفا حداقل یک خدمت را انتخاب نمایید.');
      }

      if (!sectionFields?.name) {
        setSubmitSectionLoading(false);
        return toaster.error('لطفا نام بخش را وارد کنید.');
      }

      const response = isEditingSection
        ? await axios.put(
            urldashboard + url,
            JSON.stringify({
              ...sectionFields,
              businessGroupsWithVideos: businessGroupIds,
              id,
              companyId: state?.id,
            }),
            {
              headers: {
                Authorization: authentication,
                'Content-Type': 'application/json',
              },
            }
          )
        : await axios.post(
            urldashboard + url,
            JSON.stringify({
              ...sectionFields,
              businessGroupsWithVideos: businessGroupIds,
              addressId,
              companyId: state?.id,
            }),
            {
              headers: {
                Authorization: authentication,
                'Content-Type': 'application/json',
              },
            }
          );
      toaster.success(response?.data?.message);
      setSubmitSectionLoading(false);
      setSectionInfo({});
      setServices([]);
      setIsEditingSection(false);
      setSectionFormModal(false);
      getSections(addressId);
    } catch (error) {
      handelerrors(error);
      setSubmitSectionLoading(false);
      setSectionInfo({});
      setServices([]);
      setIsEditingSection(false);
      setSectionFormModal(false);
    }
  };

  return (
    <>
      <CreateCancel />
      {SohwaddFrom ? (
        <div
          style={{
            backgroundColor: 'white',
            padding: '20px',
            borderRadius: '15px',
          }}
        >
          <AddressForm companyId={state?.id} />
        </div>
      ) : (
        <>
          <Row
            gutter={20}
            style={{
              marginTop: 25,
            }}
          >
            <Col
              xs={24}
              sm={24}
              md={24}
              lg={24}
              xl={24}
              style={{ marginBottom: 20 }}
              className='d-flex align-items-baseline'
            >
              <h4 className='ml-2'>آدرسهای شرکت</h4>
              <h1
                style={{
                  fontSize: '3rem',
                  fontWeight: '100',
                  color: '#8b8b8b',
                }}
              >
                {state?.name}
              </h1>
            </Col>
          </Row>
          <Row
            gutter={20}
            style={{
              marginTop: 25,
            }}
          >
            <Col
              xs={24}
              sm={24}
              md={24}
              lg={12}
              xl={12}
              style={{ marginBottom: 20 }}
            >
              <InputGroup>
                <Input
                  placeholder='جستجوی سریع (آدرس)'
                  name='searchValue'
                  onChange={(e) => setSearchValue(e.target.value)}
                  style={{
                    height: '3rem',
                    width: '90%',
                    display: 'table-cell',
                  }}
                />
                <Button
                  onClick={search}
                  style={{
                    height: '3rem',
                    width: '10%',
                    display: 'table-cell',
                    padding: 0,
                  }}
                >
                  <i className='mdi mdi-magnify'></i>
                </Button>
              </InputGroup>
            </Col>
            <Col xs={24} sm={24} md={24} lg={12} style={{ marginBottom: 20 }}>
              <Space
                wrap
                style={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  width: '100%',
                }}
              >
                <Excel
                  data={data}
                  headers={headers}
                  fileName={`آدرسهای_${state?.name}`}
                />
                <Button
                  block
                  onClick={() => history.push('/BusinessCompany')}
                  style={{ height: '3rem' }}
                  type='primary'
                  className='btn btn-warning border border-secondary rounded-0'
                >
                  بازگشت
                  <i className='mdi mdi-chevron-left mr-2'></i>
                </Button>
              </Space>
            </Col>
          </Row>

          <Table
            size='small'
            style={{ textAlign: 'right', marginTop: 10 }}
            rowClassName={() => 'center'}
            columns={columns}
            bordered={true}
            dataSource={data}
            loading={loading}
            pagination={false}
            locale={{
              emptyText: 'موردی یافت نشد',
            }}
          />

          {!loading && (
            <CustomPagination
              totalRecord={totalRecord}
              pagination={pagination}
              handlePagination={handlePagination}
              notMain
            />
          )}

          {deleteModal && (
            <ModalDelete
              showitem={deleteModal}
              handleCloseMoudal={() => setDeleteModal(false)}
              handeldeleteModal={() => setDeleteModal(false)}
              id={addressId}
            />
          )}

          {sectionsModal && (
            <Modal
              title={
                <div>
                  <div className='d-flex justify-content-between align-items-center mb-4'>
                    <div className='d-flex flex-column'>
                      <span style={{ color: '#939393' }}>بخش‌های آدرس </span>
                      <Tooltip title={addressInfo?.addressName}>
                        <span style={{ color: '#000000' }}>
                          {`${addressInfo?.addressName?.substring(0, 200)}${
                            addressInfo?.addressName?.length > 200 ? '...' : ''
                          }`}
                        </span>
                      </Tooltip>
                    </div>
                    <Button
                      key='back'
                      type='link'
                      onClick={() => setSectionsModal(false)}
                    >
                      <i
                        className='mdi mdi-close'
                        style={{ fontSize: '1rem', color: '#939393' }}
                      ></i>
                    </Button>
                  </div>
                  <Button
                    block
                    key='submit'
                    type={'primary'}
                    onClick={handleAddSection}
                  >
                    افزودن ＋
                  </Button>
                </div>
              }
              open={sectionsModal}
              onCancel={() => setSectionsModal(false)}
              closable={false}
              footer={null}
              bodyStyle={{ maxHeight: 600, overflowY: 'auto' }}
              width={1500}
            >
              <Table
                size='small'
                rowClassName={() => 'center'}
                columns={sectionColumns}
                bordered={true}
                dataSource={sections}
                loading={sectionsLoading}
                pagination={false}
                locale={{
                  emptyText: 'موردی یافت نشد',
                }}
              />
            </Modal>
          )}

          {sectionsFormModal && (
            <Modal
              title={isEditingSection ? 'ویرایش اطلاعات بخش' : 'افزودن بخش'}
              open={sectionsFormModal}
              onCancel={() => {
                setSectionInfo({});
                setServices([]);
                setIsEditingSection(false);
                setSectionFormModal(false);
              }}
              closable={false}
              footer={[
                <Button
                  block
                  key='submit'
                  type={'primary'}
                  loading={submitSectionLoading}
                  onClick={() => submitSection()}
                >
                  ثبت
                </Button>,
              ]}
              bodyStyle={{ maxHeight: 600, overflowY: 'auto' }}
            >
              <Row gutter={20}>
                <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                  <InputFarsi
                    label='بخش'
                    defaultValue={sectionInfo.name}
                    name='name'
                    handelValue={(_, value) =>
                      setFormData({ ...formData, name: value })
                    }
                  />
                </Col>
                <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                  <InputFarsi
                    label='کد'
                    defaultValue={sectionInfo.costCentreCode}
                    name='costCentreCode'
                    handelValue={(_, value) =>
                      setFormData({ ...formData, costCentreCode: value })
                    }
                  />
                </Col>
              </Row>
              <Row gutter={20}>
                <Col span={24}>
                  <Divider>{'خدمات'}</Divider>
                  <Table
                    size='small'
                    rowClassName={() => 'center'}
                    columns={servicesColumns}
                    bordered={true}
                    dataSource={services}
                    loading={servicesLoading}
                    pagination={false}
                    locale={{
                      emptyText: 'موردی یافت نشد',
                    }}
                  />
                </Col>
              </Row>
            </Modal>
          )}
        </>
      )}
    </>
  );
}
